import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class AccordionService {
  activeIndicesSubject = new BehaviorSubject<number[]>([]);
  activeIndices$ = this.activeIndicesSubject.asObservable();

  toggle(index: number) {
    const currentIndices = this.activeIndicesSubject.value;
    const indexPosition = currentIndices.indexOf(index);

    if (indexPosition !== -1) {
      currentIndices.splice(indexPosition, 1);
      this.activeIndicesSubject.next([...currentIndices]);
    } else {
      this.activeIndicesSubject.next([...currentIndices, index]);
    }
  }

  open(index: number) {
    const currentIndices = this.activeIndicesSubject.value;
    if (!currentIndices.includes(index)) {
      this.activeIndicesSubject.next([...currentIndices, index]);
    }
  }

  closeAll() {
    this.activeIndicesSubject.next([]);
  }
}
